import { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, TextInput } from "@/components/common/Forms";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell>
      <p className="eyebrow mb-4">Recupero password</p>
      <h1 className="text-4xl font-light">Nessun problema.</h1>
      {sent ? (
        <div data-testid="forgot-password-sent" className="mt-6 space-y-6">
          <p className="text-sm text-warm-text leading-relaxed">Se l'indirizzo è registrato, riceverai a breve un'email con il link per scegliere una nuova password. Il link resta valido per un'ora.</p>
          <Link to="/accedi" className="btn-ghost w-full">Torna all'accesso</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-6">
          <p className="text-sm text-warm-text">Inserisci l'email del tuo account: ti invieremo un link per reimpostare la password.</p>
          <Field label="Email"><TextInput data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <button data-testid="forgot-submit-btn" disabled={busy} className="btn-gold w-full">Invia il link</button>
          <Link to="/accedi" className="btn-link block text-center">Torna all'accesso</Link>
        </form>
      )}
    </AuthShell>
  );
}
